import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from 'react-bootstrap';
import styled from "styled-components";
import Button from "../../globals/Button";
import ButtonGroup from "../../globals/ButtonGroup";
import Calendar from "../../globals/dhtmlx/Calendar";
import Switch from "../../globals/Switch";
import CalendarComplex from "../../globals/CalendarComplex";
import HeaderGrid from "./HeaderGrid";
import './Toolbar.css'
import { dateToString, setShortFormart, ObtnerSemanaAnterior, apiDate } from "../../../helpers/Date";
import '../../../assets/bootstrap/css/bootstrap.min.css'
import ModalConsignacionesUPC from "./ModalConsignacionesUPC";
import ModalConsignacionesCompra from "./ModalConsignacionesCompra";

const ToolBar = styled(Row)`
  min-height: 58px;
  margin:8px 0 ;
  padding: 8px;
  border: 1px solid #e4e4e4;
  background-color: #f7f7f7;
  align-items: center;
`;

const DateContainer = styled(Col)`
  display:flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0,0,0,.7);
  font-weight: 500;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
`;
const DatePicker = styled.div`
  padding: 0;
`;
const DateButton = styled.div`
  display:flex;
  align-items:center;
  span {
    color: ${props => props.historico ? '#E4E4E4' : 'black'};
    cursor:${props => props.historico ? 'default' : 'pointer'};
  }
  &:hover{
    
  }
`;
const CalendarContainer = styled.div`
  background-color:white;
  position: absolute;
  z-index: 10000;
  border: 1px solid #efefef;
  border-radius:8px;
  box-shadow: -1px 1px 10px rgba(0,0,0,0.19),0 3px 3px rgba(0,0,0,0.13);
`;
const ButtonContainer = styled.div`
 
  display: flex;
  justify-content:end;
  button {
    margin: 8px;
  }
`;
const Separador = styled.span`
  width: 1px;
  min-width: 1px;
  height: 100%;
  background-color: #dfdfdf;
  margin: 0 8px;
  height: 28px;
`;
const Label = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0,0,0,.7);
  font-weight: normal;
  margin-right:8px;
`;
const ColS = styled(Col)`
  margin:0;
  padding: 0;

`;


const fechasIniciales = ObtnerSemanaAnterior();
const setDataFiltro = (concepto) => {
  let itemsBox = [];
  let defaultValue = "";
  switch (concepto) {
    case 'upc':
      defaultValue = 'upc';
      itemsBox = [
        {
          value: "upc",
        },
        {
          value: "nombre",
        },
        {
          value: "plataforma",
        },
        {
          value: "categoria",
        },
        {
          value: "publisher",
        }
      ];
      break;
    case 'categoria':
      defaultValue = 'categoria';
      itemsBox = [
        {
          value: "categoria",
        }
      ];
      break;
    case 'id_compra':
      defaultValue = 'id_compra';
      itemsBox = [
        {
          value: "id_compra",
        },
        {
          value: "no_factura",
        },
        {
          value: "fecha_compra_efectiva",
        }
      ];
      break;
    case 'publisher':
      defaultValue = 'publisher';
      itemsBox = [
        {
          value: "publisher",
        }
      ];
      break;
    default:
      defaultValue = 'upc';
      itemsBox = [
        {
          value: "upc",
        },
        {
          value: "nombre",
        },
        {
          value: "plataforma",
        },
        {
          value: "categoria",
        },
        {
          value: "publisher",
        }
      ];
      break;
  }
  let config = [
    {
      type: "spacer"
    },
    {
      id: "title-filtro",
      type: "title",
      value: "Filtro:"
    },
    {
      id: "filterButton",
      type: "selectButton",
      value: defaultValue,
      items: itemsBox,
    },
    {
      id: "search",
      type: "input",
      placeholder: "Buscar",
      icon: "dxi dxi-magnify",
      value: ""
    }
  ];
  return config;
}
function ToolbarGrid(props) {

  /** Estados */


  const firstDate = fechasIniciales.firstDate;
  const secondDate = fechasIniciales.secondDate;

  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([firstDate, secondDate]);
  const [stringDateRange, setStringDateRange] = useState([dateToString(firstDate), dateToString(secondDate)]);

  const [comparar, setComparar] = useState(false);
  const [dateRangeCompare, setDateRangeCompare] = useState([]);
  const [stringDateRangeCompare, setStringDateRangeCompare] = useState([]);

  const [filtroConfig, setFiltroConfig] = useState(setDataFiltro('upc'));

  const [showModalUPC, setShowModalUPC] = useState(false);
  const [showModalIDCompra, setShowModalIDCompra] = useState(false);

  useEffect(() => {
    setFiltroConfig(setDataFiltro(props.actualConcepto));
  }, [props.gridReady]);
  useEffect(() => {
    props.toogleComparar(comparar);

  }, [comparar]);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  /**
   * Hook that alerts clicks outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowCalendar(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const clickCalendar = (e) => {
    console.log(e);
    if (!props.isDetalleHistorico) {
      setShowCalendar(!showCalendar);
    }
  };
  //afectan el contenido
  function aplySelectedDate() {
    setStringDateRange([setShortFormart(dateRange[0]), setShortFormart(dateRange[1])])

    props.toogleDateRange(dateRange);
    if (comparar) {
      setStringDateRangeCompare([setShortFormart(apiDate(dateRangeCompare[0])), setShortFormart(apiDate(dateRangeCompare[1]))])
      //actualizamos el estado del reporte
      props.toogleDateRangeCompare([apiDate(dateRangeCompare[0]), apiDate(dateRangeCompare[1])]);
    }

    clickCalendar();
  }
  const grupoVista = [
    {
      id: 'dia',
      value: 'Día',
    },
    {
      id: 'semana',
      value: 'Semana',
    },
    {
      id: 'mes',
      value: 'Mes',
    },
    {
      id: 'anio',
      value: 'Año',
    }
  ];
  const grupoConcepto = [
    {
      id: 'upc',
      value: 'UPC',
    },
    {
      id: 'categoria',
      value: 'Categoria',
    },
    {
      id: 'id_compra',
      value: 'Id Compra',
    },
    {
      id: 'publisher',
      value: 'Publisher',
    }
  ];
  function toogleEstadoSwitch() {
    props.toogleEstadoSwitch(!props.estadoSwitch)
  }
  function toogleDateRange(dateRangeObject) {
    if (dateRangeObject.principal) {
      let dateRange = dateRangeObject.principal
      let inicio = apiDate(dateRange.startDate);
      let fin = apiDate(dateRange.endDate);
      console.log("range", inicio, fin);
      setDateRange([inicio, fin]);
    }

    if (dateRangeObject.compare) {
      let dateRangeC = dateRangeObject.compare
      let inicioC = (dateRangeC.startDate);
      let finC = (dateRangeC.endDate);
      console.log("range compare", inicioC, finC);
      setDateRangeCompare([inicioC, finC]);
    }
    return true;
  }
  return (
    <ToolBar>
      <DateContainer md={'auto'} style={{ padding: '0 8px' }}>
        <DatePicker>
          <DateButton id={"date_button"} onClick={clickCalendar} historico={props.isDetalleHistorico}>
            <span>Periodo: </span>
            <div style={{ marginLeft: '8px' }}>
              <div>
                <span style={{
                  fontWeight: 500,
                  backgroundColor: 'WHITE',
                  boxShadow: 'inset 0 0 0 1px #dfdfdf',
                  padding: '4px 8px',
                  marginLeft: '8px'

                }}>{stringDateRange[0]} - {stringDateRange[1]}
                  <span style={{ marginLeft: '8px' }} className={showCalendar ? "fa fa-caret-up" : "fa fa-caret-down"}></span>
                </span>
              </div>

              <div style={{ display: (comparar && stringDateRangeCompare.length > 0) ? '' : 'none', fontSize: '12px', fontWeight: 400, marginLeft: '8px', marginTop: '4px' }}>
                <span >vs. {stringDateRangeCompare[0]} - {stringDateRangeCompare[1]}</span>
              </div>
            </div>


          </DateButton>
          <CalendarContainer ref={wrapperRef} id="calendar_container" hidden={!showCalendar}>
            {/* <Calendar value={dateRange} toogleDateRange={toogleDateRange}/> */}
            <CalendarComplex
              cancel={clickCalendar}
              toogleDateRange={toogleDateRange}
              apply={aplySelectedDate}
              toogleComparar={val => setComparar(val)}
            />

          </CalendarContainer>
        </DatePicker>
      </DateContainer>
      <Separador />
      <ColS md={'auto'}>
        <Label>Vista:</Label>
        <ButtonGroup
          buttons={grupoVista}
          disable={!props.showGraph}
          toogleAction={props.toogleVista}
          cargando={!props.graphReady}

        />
      </ColS>
      <Separador />
      <ColS md={'auto'}>
        <Label>Concepto:</Label>
        <ButtonGroup
          buttons={grupoConcepto}
          disable={props.isDetalle}
          toogleAction={props.toogleConcepto}
          cargando={!props.gridReady}
        />
      </ColS>
      <Separador />
      <ColS md={'auto'}>
        <Switch
          checked={props.estadoSwitch}
          onChange={toogleEstadoSwitch}
          tooltip={"Mostar/Ocultar Registros Nulos"}
          disable={props.isDetalle}
        />
      </ColS>
      <ColS className="mx-4">

        {
          //Cosnignaciones por UPC
          (
            !props.isDetalle && props.showDetalleOptions.ver && props.actualSelectedRowsComplete.length === 1 && props.actualConcepto === 'upc') && (
            <>
              <Button
                border
                flat
                onClick={() => { setShowModalUPC(true) }}

              >
                Historico de Consignaciones
              </Button>
              <ModalConsignacionesUPC
                show={showModalUPC}
                onHide={() => { setShowModalUPC(false) }}
                producto={props.actualSelectedRowsComplete.length ? props.actualSelectedRowsComplete[0] : null}
                filtroConfig={props.actualConcepto}
              />
            </>

          )
        }
        {
          //Cosnignaciones por id Compra
          (
            !props.isDetalle && props.showDetalleOptions.ver && props.actualSelectedRowsComplete.length === 1 && props.actualConcepto === 'id_compra') && (
            <>
              <Button
                border
                flat
                onClick={() => { setShowModalIDCompra(true) }}

              >
                Detalle de Consignación
              </Button>
              <ModalConsignacionesCompra
                show={showModalIDCompra}
                onHide={() => { setShowModalIDCompra(false) }}
                producto={props.actualSelectedRowsComplete.length ? props.actualSelectedRowsComplete[0] : null}
                filtroConfig={props.actualConcepto}
              />
            </>

          )
        }
      </ColS>


      {/* <Separador/>
      <ColS md={'auto'} hidden={props.showDetalleOptions.ver? false:true}>
        <button className={'customButton'} onClick={props.verDetalle}>
          Ver Detalles
        </button>
      </ColS>
      <ColS md={'auto'} hidden={props.isDetalle?false:true}>
        <button className={'customButton'} onClick={props.regresarDetalle}>
          <span className="fa fa-arrow-left" style={{marginRight:'4px'}}></span>
          Regresar Nivel Superior
        </button>
        <span className="span-rows-selected">{props.actualSelectedRows}</span>
        <span className="fa fa-question-circle tooltip-bar">
          <span className="tooltiptext">Elementos Seleccionados: {formatTooltip(props.actualSelectedRowsComplete)}</span>
        </span>
      </ColS> */}
      <ColS hidden={props.isDetalle || props.showDetalleOptions.ver ? true : false}>
        <HeaderGrid
          toogleInput={props.toogleFiltro}
          actualConcepto={props.actualConcepto}
          gridReady={props.gridReady}
          data={filtroConfig}
        />

      </ColS>
    </ToolBar>
  );
}
export default ToolbarGrid;